// extracted by mini-css-extract-plugin
export default {"card":"MiniDisplay_card__YW6Qz","card-container":"MiniDisplay_card-container__aNfSX"};